import { Button, Drawer, Switch } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid'
import axios from 'axios';
import React, { useEffect, useMemo, useState } from 'react'
import { v4 } from 'uuid';
import TicketPopup2 from './TicketPopup2';

const Category = () => {


  const [data, setData] = useState([]);
  const [preData, setPreData] = useState([]);
  const [open, setOpen] = useState(false);
  const toggleModal = () => setOpen(!open)
  const [popupData, setPopupData] = useState(null)


    useEffect(() => {
        if (!preData) return;
    var serialno=1;
        const _rData = preData.map((columnData) => 
            {
                const subCategoryNames = columnData.subcategory 
        ? columnData.subcategory.map(subCat => subCat.name).join(', ')
        : '-';
        return { id: v4(),
          SL_NO:serialno++,
          CATEGORY: columnData.name ,
          SUB_CATEGORY: subCategoryNames,
          STATUS: columnData.status || 0,
        active:columnData.active,
        _id:columnData._id,
        emailist:columnData.emailList

        }
        });
    
        setData(_rData);
      }, [preData]);
    
      useEffect(() => {
        let isMounted = true;
    
        const fetchData = async () => {
          try {
            const token = localStorage.getItem("token");
    
            const response = await axios.get(
              "https://jk-msfa-dev-api.jktyre.co.in/api/v1/query/QueryCategorygetAll?status=ALL",
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
    
            if (isMounted) {
              console.log("Data ", response.data.categories);
              setPreData(response.data.categories);
            }
          } catch (error) {
            if (isMounted) {
              console.error("Error fetching data:", error);
            }
          }
        };
    
        fetchData();
    
      
      }, []);
    
      const patchData = async (datatopatch) => {
        try {
            const token = localStorage.getItem('token');

          const response = await axios.patch( 'http://localhost:8028/api/v1/query/updateStatus', datatopatch,{
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json', // Adjust content type if necessary
            },
          });
          console.log('Response:', response.data);
     return;
        } catch (error) {
          console.error('Error:', error.response ? error.response.data : error.message);
          throw error;
        }
      };
      

      const handleSwitchChange = (row)=>async (event) => {
   
           

        const updatedData = data.map((d) =>
          d._id === row._id ? { ...d, active: event.target.checked} : d
        );
       
        const datatopatch={
            changeStatus:true,
            id:row._id,

        }
       

        try {
           await patchData(datatopatch)
          } catch (error) {
            // Revert the change if the patch request fails
            setPreData(updatedData);
          }
        
      
      };


      const columns = useMemo(
        () => [
          {
            field: "SL_NO",
            headerName: "SL.NO.",
            // width: 150,
            flex: 1,
          },
          {
            field: "CATEGORY",
            headerName: "CATEGORY",
            // width: 100,
            flex: 1,
          },
          {
            field: "SUB_CATEGORY",
            headerName: "SUB CATEGORY",
            // width: 100,
            flex: 1,
          },
          {
            field: "STATUS",
            headerName: "STATUS",
            // width: 100,
            flex: 1,
            renderCell: ({ row }) => (
                <Switch
      checked={row.active}
      onChange={handleSwitchChange(row)}
      inputProps={{ 'aria-label': 'controlled' }}
    />
                )
          },
          {
            field: "DEATILS",
            headerName: "",
            // width: 100,
            flex: 1,
            renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    setPopupData(row)

                   setOpen(true)
                 //  console.log('category row data:',row);
                  }}
                  variant='contained'
                  color='primary'
                  size='small'
                >
                  Take Action
                </Button>
                )
          },
        ],
        []
      );
  return (
    <div>
      
        <DataGrid
          rows={data}
          columns={columns}
          autoHeight={true}
       //   pageSize={pageSize}
          //onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          className="TableCell"
          rowsPerPageOptions={[10, 25, 50, 100]}
          sx={{ fontSize: "0.75rem" }}
        />
      <Drawer
        open={open}
        anchor='right'
        variant='temporary'
        onClose={toggleModal}
        sx={{ '& .MuiDrawer-paper': { width: [400, 500] } }}
      >
        <TicketPopup2 toggle={toggleModal} popupData={popupData} />
      </Drawer>
    </div>
  )
}

export default Category
